<div class="card">
  <mat-card [style.border]="'1px solid #BEBEBE'">
    <mat-card-content>
        <div id="ball-container">
            <div id="ball" class="rotate"></div>
        </div>
    </mat-card-content>
  </mat-card>
</div>